import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { GetUserInfo } from "../../utils/permissionChecker";
import {
  get_project_data,
  get_project_jobs,
  AssignProjectLabor,
} from "../../services/projectApi";
import { toast } from "react-toastify";
const AssignProjectForm = ({ parentID, onSubmitButton }) => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const [formerror, setFormError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    labor_id: parentID,
    project_id: "",
    job_id: "",
    status: 1,
    created_by: currentUser,
    updated_by: currentUser,
  });
  const queryClient = useQueryClient();
  const registrationMutation = useMutation(async (data) => {
    await AssignProjectLabor(data);
    queryClient.invalidateQueries("labor_list");
  });
  const project_Query = useQuery(["project"], () => get_project_data());
  const projectJob_Query = useQuery(["project_Jobs"], () => get_project_jobs());
  if (project_Query.isLoading || projectJob_Query.isLoading) {
    return <div>Loading...</div>;
  }

  if (project_Query.isError) {
    return <div>Error: {project_Query.error.message}</div>;
  }

  if (projectJob_Query.isError) {
    return <div>Error: {projectJob_Query.error.message}</div>;
  }

  const projectdata = project_Query.data.data.projects;
  const projectJobs = projectJob_Query.data;
  const handleRegistration = async (Data) => {
    try {
      setIsSubmitting(true);
      await registrationMutation.mutateAsync(Data);
      toast.success("Assigned successfully", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      handleCloseModal();
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const requiredFields = ["job_id", "project_id", "labor_id"];
    const isEmptyField = requiredFields.some((field) => !formData[field]);
    if (isEmptyField) {
      setFormError(true);
      return;
    }
    handleRegistration(formData);
  };

  const handleCloseModal = () => {
    onSubmitButton();
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        {formerror ? (
          <Alert variant="danger">
            <p>Please tray again all fields are required.</p>{" "}
          </Alert>
        ) : (
          ""
        )}
        <Form.Group>
          <Form.Label
            htmlFor="inputReason"
            className="font-weight-bold text-muted"
          >
            {t("project")}
          </Form.Label>
          <select
            id="inputReason"
            className="form-select form-control choicesjs"
            value={formData.project_id}
            onChange={(e) => handleInputChange(e, "project_id")}
          >
            <option value="" hidden disabled>
              Select project
            </option>
            {projectdata &&
              projectdata.map((data) => (
                <option key={data.id} value={data.id}>
                  {data.name}
                </option>
              ))}
          </select>
        </Form.Group>

        <Form.Group>
          <Form.Label
            htmlFor="inputPosition"
            className="font-weight-bold text-muted"
          >
            {t("job_role")}
          </Form.Label>
          <select
            id="inputPosition"
            className="form-select form-control choicesjs"
            value={formData.job_id}
            onChange={(e) => handleInputChange(e, "job_id")}
          >
            <option value="" hidden disabled>
              Select job
            </option>
            {projectJobs &&
              projectJobs.map((data) => (
                <option key={data.id} value={data.id}>
                  {data.job_title}
                </option>
              ))}
          </select>
        </Form.Group>

        <div className="d-flex mt-1">
          <div className="mb-1">
            <Button className="btn btn-secondary" onClick={handleCloseModal}>
              {t("cancel")}
            </Button>
          </div>
          <div className="col-md-6 mb-1">
            <Button
              className="btn btn-info"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Sending...</span>
                </span>
              ) : (
                t("assign")
              )}
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default AssignProjectForm;
